import { useEffect, useState } from "react";
import { contactInfo } from "@/mocks/home";

export default function FloatingButtons() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="fixed bottom-5 right-4 z-40 flex flex-col gap-2.5 md:bottom-8 md:right-6">
      <a
        href={contactInfo.phoneHref}
        aria-label="전화 상담"
        className="group flex h-16 w-16 flex-col items-center justify-center gap-0.5 rounded-md bg-primary-500 text-background-50 transition-transform duration-200 hover:-translate-y-0.5 hover:bg-primary-600"
      >
        <i className="ri-phone-fill text-[22px] leading-none"></i>
        <span className="font-label text-[10px] font-bold leading-none">전화</span>
      </a>

      <a
        href={contactInfo.kakaoHref}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="카카오톡 상담"
        className="group flex h-16 w-16 flex-col items-center justify-center gap-0.5 rounded-md bg-accent-500 text-primary-950 transition-transform duration-200 hover:-translate-y-0.5 hover:bg-accent-600"
      >
        <i className="ri-kakao-talk-fill text-[22px] leading-none"></i>
        <span className="font-label text-[10px] font-bold leading-none">카톡</span>
      </a>

      <button
        type="button"
        onClick={scrollTop}
        aria-label="맨 위로 가기"
        className={`flex h-16 w-16 flex-col items-center justify-center gap-0.5 rounded-md border border-background-300 bg-background-50 text-foreground-900 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-400 hover:text-primary-600 ${
          showTop ? "pointer-events-auto opacity-100" : "pointer-events-none translate-y-2 opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line text-[22px] leading-none"></i>
        <span className="font-label text-[10px] font-bold leading-none">TOP</span>
      </button>
    </div>
  );
}